import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.207 8.25H13.75V3.667a.92.92 0 0 0-.917-.917H9.166a.92.92 0 0 0-.916.917V8.25H6.792c-.816 0-1.228.99-.65 1.568l4.207 4.207a.913.913 0 0 0 1.292 0l4.208-4.207c.577-.578.174-1.568-.642-1.568ZM4.583 17.417a.92.92 0 0 0 .917.916h11a.92.92 0 0 0 .916-.916.92.92 0 0 0-.916-.917h-11a.92.92 0 0 0-.917.917Z",
    fill: "#fff"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h22v22H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };